import { wasteDirectionEnum } from '../enums';

export const getWasteDirectionLabel = (direction: number): string => {
    switch (direction) {
        case wasteDirectionEnum.IN:
            return 'incoming';
        case wasteDirectionEnum.OUT:
            return 'outgoing';
        default:
            return 'unknown';
    }
};
